var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9725 17.1145H21.5098V20.5772H24.9725V17.1145ZM24.0402 19.645H22.442V18.0468H24.0402V19.645Z",
    fill: "#2F3639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3773 12.5196H16.9146V15.9825H20.3773V12.5196ZM19.445 15.0502H17.8468V13.4521H19.445V15.0502Z",
    fill: "#2F3639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59262 17.1145H3.16309V20.5772H6.62579L6.62602 17.1145H6.59262ZM5.66032 19.645H4.06215V18.0468H5.66032V19.645Z",
    fill: "#2F3639"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59262 21.7092H3.16309V25.1719H6.62579L6.62602 21.7092H6.59262ZM5.66032 24.2397H4.06215V22.6415H5.66032V24.2397Z",
    fill: "#2F3639"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9725 12.5196H21.5098V15.9825H24.9725V12.5196ZM24.0402 15.0502H22.442V13.4521L24.0402 13.4518V15.0502Z",
    fill: "#2F3639"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3773 21.7092H16.9146V25.1719H20.3773V21.7092ZM19.445 24.2397H17.8468V22.6415H19.445V24.2397Z",
    fill: "#2F3639"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7823 17.1145H12.3193V20.5772H15.782L15.7823 17.1145ZM14.85 19.645H13.2518V18.0468H14.85V19.645Z",
    fill: "#2F3639"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1878 21.7092H7.7251V25.1719H11.1878V21.7092ZM10.2555 24.2397H8.65734V22.6415H10.2555V24.2397Z",
    fill: "#2F3639"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7823 12.5196H12.3193V15.9825H15.782L15.7823 12.5196ZM14.85 15.0502H13.2518V13.4521H14.85V15.0502Z",
    fill: "#2F3639"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1878 12.5196H7.7251V15.9825H11.1878V12.5196ZM10.2555 15.0502H8.65734V13.4521H10.2555V15.0502Z",
    fill: "#2F3639"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3773 17.1145H16.9146V20.5772H20.3773V17.1145ZM19.445 19.645H17.8468V18.0468H19.445V19.645Z",
    fill: "#2F3639"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1878 17.1145H7.7251V20.5772H11.1878V17.1145ZM10.2555 19.645H8.65734V18.0468H10.2555V19.645Z",
    fill: "#2F3639"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7823 21.7092H12.3193V25.1719H15.782L15.7823 21.7092ZM14.85 24.2397H13.2518L13.2516 22.6415H14.8497L14.85 24.2397Z",
    fill: "#2F3639"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5039 1.46516H21.7092C21.5095 0.632752 20.7769 6.10352e-05 19.8778 6.10352e-05C18.9788 6.10352e-05 18.2463 0.632752 18.0133 1.46516H10.0888C9.88901 0.632752 9.12327 6.10352e-05 8.22421 6.10352e-05C7.32515 6.10352e-05 6.59263 0.632752 6.35967 1.46516H1.59817C0.732521 1.46516 0 2.16451 0 3.06333V28.4019C0 29.2675 0.699344 30.0001 1.59817 30.0001H26.4706C27.3362 30.0001 28.0687 29.3007 28.0687 28.4019L28.069 3.03003C28.069 2.16421 27.3696 1.4651 26.504 1.4651L26.5039 1.46516ZM18.9124 1.89809C18.9124 1.36529 19.3453 0.93261 19.8778 0.93261C20.4106 0.93261 20.8433 1.36553 20.8433 1.89809V3.19665C20.8433 3.72944 20.4104 4.16212 19.8778 4.16212C19.345 4.16212 18.9124 3.7292 18.9124 3.19665V1.89809ZM7.25862 1.89809C7.25862 1.36529 7.69154 0.93261 8.22409 0.93261C8.75689 0.93261 9.18957 1.36553 9.18957 1.89809V3.19665C9.18957 3.72944 8.75664 4.16212 8.22409 4.16212C7.6913 4.16212 7.25862 3.7292 7.25862 3.19665V1.89809ZM0.965596 3.0301C0.965596 2.66383 1.26521 2.39741 1.59829 2.39741H6.29314V3.19659C6.29314 4.26219 7.15879 5.12778 8.22433 5.12778H8.49073C9.45621 4.99469 10.1888 4.12883 10.1888 3.12988V2.39735H17.9469V3.19653C17.9469 4.26213 18.8125 5.12772 19.878 5.12772H20.1444C21.1099 4.99463 21.8425 4.12877 21.8425 3.12982V2.39729H26.5374C26.9036 2.39729 27.17 2.69691 27.17 3.02999V8.65714H0.965774L0.965596 3.0301ZM27.1366 28.3687C27.1366 28.7349 26.837 29.0014 26.5039 29.0014H1.59817C1.2319 29.0014 0.965477 28.7017 0.965477 28.3687L0.965709 9.65609H27.1367L27.1366 28.3687Z",
    fill: "#2F3639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.85c201f8593f38aab57c5e6811bb61b7.svg";
export { ForwardRef as ReactComponent };